import { ACCEPTED_UPLOAD_IMAGE_TYPES, MAX_PRODUCT_MEDIA_SIZE_BYTES } from "@shared/products/photo-constraints";

export interface UploadPolicy {
  readonly contentTypes: ReadonlyArray<string>;
  readonly maxBytes: number;
  readonly acceptedLabel: string;
}

const TEN_MEGABYTES = 10 * 1024 * 1024;

export const UPLOAD_CLAIM_WINDOW_MS = 60 * 60 * 1000;

export const COMPANY_DOCUMENT_UPLOAD_POLICY: UploadPolicy = {
  contentTypes: ["application/pdf", "image/jpeg", "image/png"],
  maxBytes: TEN_MEGABYTES,
  acceptedLabel: "a PDF, JPG, or PNG",
};

export const ORDER_DOCUMENT_UPLOAD_POLICY: UploadPolicy =
  COMPANY_DOCUMENT_UPLOAD_POLICY;

export const PURCHASE_ORDER_UPLOAD_POLICY: UploadPolicy = {
  contentTypes: [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "image/heic",
    "image/heif",
  ],
  maxBytes: TEN_MEGABYTES,
  acceptedLabel: "a PDF or image (PNG, JPG, HEIC/HEIF)",
};

export const LEAD_MAIL_ATTACHMENT_POLICY: UploadPolicy = {
  contentTypes: ["application/pdf", "image/jpeg", "image/png", "image/heic", "image/heif"],
  maxBytes: TEN_MEGABYTES,
  acceptedLabel: "a PDF or image (PNG, JPG, HEIC/HEIF)",
};

export const SIGNATURE_UPLOAD_POLICY: UploadPolicy = {
  contentTypes: ["image/png"],
  maxBytes: TEN_MEGABYTES,
  acceptedLabel: "a PNG signature",
};

export const BLOG_COVER_UPLOAD_POLICY: UploadPolicy = {
  contentTypes: ACCEPTED_UPLOAD_IMAGE_TYPES.filter((type) => type !== "image/heic" && type !== "image/heif"),
  maxBytes: MAX_PRODUCT_MEDIA_SIZE_BYTES,
  acceptedLabel: "a JPEG, PNG, WebP, AVIF or GIF cover image",
};
